module.exports = __webpack_public_path__ + "img/blank-artist.ce6e2087.png";